<template>
  <div>
    <basic-container>
      <el-form :model="info" :rules="rules" ref="infoForm" label-width="120px">
        <el-card shadow="hover" class="card" v-if="info.shopName || info.shopMobile || info.shopAddress">
          <div slot="header" class="clearfix">
            <span>店铺信息:</span>
          </div>
          <el-row>
            <el-col :span="8"><strong>店铺名称:</strong> {{ info.shopName || '--' }}</el-col>
            <el-col :span="8"><strong>店铺电话:</strong> {{ info.shopMobile || '--' }}</el-col>
            <el-col :span="8"><strong>店铺地址:</strong> {{ info.shopAddress || '--' }}</el-col>
          </el-row>
        </el-card>
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>商户报单信息:</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="销售部门" prop="region">
                <el-input v-model="info.region"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="施工地址(区/县)" prop="customAddress">
                <el-input v-model="info.customAddress"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="户型" prop="houseType">
                <el-input v-model="info.houseType"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否回填" prop="backFill">
                <el-select v-model="info.backFill" placeholder="选择是否回填">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="付款人姓名" prop="contactName">
                <el-input v-model="info.contactName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款人手机号" prop="contactMobile">
                <el-input v-model="info.contactMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="业主姓名" prop="contactName">
                <el-input v-model="info.customName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业主手机号" prop="contactMobile">
                <el-input v-model="info.customMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="预付款">
                <el-input v-model="info.advanceCharge"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回填坑位数量" prop="voucher">
                <el-input v-model="info.voucher"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="质保人电话" prop="payee">
                <el-input v-model="info.payee"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报单日期" prop="declarationDate">
                <el-date-picker v-model="info.declarationDate" type="date" placeholder="选择报单日期"
                  @change="handleDateChange"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="进场时间" prop="entranceTime">
                <el-date-picker v-model="info.entranceTime" type="datetime" @change="handleEntranceTimeChange"
                  placeholder="选择预计进场时间"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="楼层" prop="floor">
                <el-input v-model="info.floor"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="8">
              <el-form-item label="渠道" prop="recipientPay">
                <el-select v-model="info.recipientPay" placeholder="选择渠道">
                  <el-option v-for="item in recipientPayOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="装饰公司/商家名称" prop="paymentTarget">
                <el-input v-model="info.paymentTarget"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="业务员" prop="introducer">
                <el-input v-model="info.introducer"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="返利账号" prop="reference">
                <el-input v-model="info.reference"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="回填涂料种类" prop="paintType">
                <el-select v-model="info.paintType" placeholder="选择回填涂料使用种类">
                  <el-option label="蓝色" value="蓝色"></el-option>
                  <el-option label="橙色" value="橙色"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="picUrl" label="付款凭证">
                <ImageUpload action="#" :multiple="true" :inTable="true" :limit="5" @uploaded="handleUploaded"
                  :uploaded-images="info.picUrl" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="info.remarks"></el-input>
          </el-form-item>
          <el-form-item v-if="selectedGoods.length > 0" label="商品列表" prop="selectedGoods">
            <el-table :data="selectedGoods" style="width: 100%" border>
              <el-table-column prop="goodsName" label="商品名称" />
              <el-table-column prop="num" label="数量" />
            </el-table>
          </el-form-item>
        </el-card>
      </el-form>
      <!-- 提交和返回按钮 -->
      <div style="width: 100%; display: flex; justify-content: center; margin-top: 20px;">
        <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
        <el-button type="primary" size="small" @click="submit" icon="el-icon-circle-check-outline">确定修改</el-button>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { getGoodList, getMerchantOrder, editMerchantOrder } from "@/api/work/waterProject/merchants";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import ImageUpload from "@/components/imageUpload/ImageUpload";
export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      goodsList: [], // 商品列表
      selectedGoods: [], // 用户选择的商品
      info: {}, // 表单数据
      fileList: [], // 上传文件列表
      recipientPayOptions: [
        { label: "经销商", value: "经销商" },
        { label: "装饰公司", value: "装饰公司" }
      ],
      rules: {
        // region: [{ required: true, message: "请输入区域", trigger: "blur" }],
        contactName: [{ required: true, message: "请输入付款人姓名", trigger: "blur" }],
        contactMobile: [{ required: true, message: "请输入付款人手机号", trigger: "blur" }],
        // customName: [{ required: true, message: "请输入业主姓名", trigger: "blur" }],
        // customMobile: [{ required: true, message: "请输入业主手机号", trigger: "blur" }],
        customAddress: [{ required: true, message: "请输入施工地址", trigger: "blur" }],
        entranceTime: [{ required: true, message: "请选择进场时间", trigger: "change" }],
        // lowerLevelType: [{ required: true, message: "请选择是否下沉式", trigger: "change" }],
        houseType: [{ required: true, message: "请输入户型", trigger: "change" }],
        area: [{ required: true, message: "请输入预估面积", trigger: "blur" }],
        backFill: [{ required: true, message: "请选择是否回填", trigger: "change" }],
        paintType: [{ required: true, message: "请选择回填涂料种类", trigger: "change" }],
        // picUrl: [{ required: true, message: "请上传付款凭证", trigger: "change" }],
        advanceCharge: [],      // 预付款可选，无需校验
        voucher: [],            // 回填坑位数量可选，无需校验
        paymentTarget: [],      // 收款对象可选，无需校验
        payee: [],              // 收款人可选，无需校验
        remarks: []             // 备注可选，无需校验
      }
    };
  },
  computed: {
  },
  created() {
    const id = this.$route.query.id;
    const number = this.$route.query.number;
    if (id) {
      getMerchantOrder(id).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          data.number = number;
          this.info = data;
          getGoodList(id).then(res => {
            if (res.code === '200') {
              let selectedGoods = JSON.parse(res.data);
              this.selectedGoods = selectedGoods.map(item => ({
                ...item,
                goodsId: item.goodsId,
                num: item.num,
                serviceOrderId: item.serviceOrderId,
                declarationId: item.declarationId,
              }));
            }
          })
          // this.findPureWaterGoodsByRootDepartId(data.list);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    }
  },
  methods: {
    handleUploaded(urls) {
      this.info.picUrl = urls;
    },
    // 处理进场时间变更
    handleEntranceTimeChange(value) {
      if (value) {
        const timestamp = new Date(value).getTime();
        this.info.entranceTime = timestamp;
      } else {
        this.info.entranceTime = null;
      }
    },
    // 处理报单日期变更
    handleDateChange(value) {
      if (value) {
        const timestamp = new Date(value).getTime();
        this.info.declarationDate = timestamp;
      } else {
        this.info.declarationDate = null;
      }
    },
    // 获取商品列表
    findPureWaterGoodsByRootDepartId(selectedGoods) {
      const type = 'waterProof'
      findPureWaterGoodsByRootDepartId(type).then(res => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = data;
            this.selectedGoods = selectedGoods.map(item => ({
              goodsId: item.goodsId,
              num: item.num,
              serviceOrderId: item.serviceOrderId,
              declarationId: item.declarationId,
              name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : ""
            }));
          } else {
            this.goodsList = [];
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    handleGoodsChange(row) {
      // 根据选择的goodsId在goodsList中查找相应的商品
      const selectedGoods = this.goodsList.find(goods => goods.id === row.goodsId);
      if (selectedGoods) {
        // 更新row中的name和goodsId
        row.goodsId = selectedGoods.id;
        row.name = selectedGoods.name;
      } else {
        // 如果未找到匹配的商品，清空name
        row.goodsId = null;
        row.name = '';
      }
    },
    // 动态添加商品
    addGoods() {
      if (this.selectedGoods.length === this.goodsList.length) {
        this.$message({
          showClose: true,
          message: "所有商品都已经选择",
          type: "warning"
        });
        return;
      } else {
        this.selectedGoods.push({ goodsId: null, num: 1 });
      }
    },
    // 移除商品
    removeGoods(index) {
      this.selectedGoods.splice(index, 1);
    },
    // 返回上一步
    goBack() {
      let item = {
        close: true,
        label: "编辑商户报单",
        value: "/work/waterProject/merchants/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    },
    // 判断商品是否可编辑
    isEditable(item) {
      return !item.serviceOrderId;
    },
    // 判断选项是否被禁用
    isOptionDisabled(goodsId) {
      return this.selectedGoods.some(item => item.goodsId === goodsId);
    },
    // 提交表单
    submit() {
      this.info.productName = this.selectedGoods.map((g) => `${g.name}*${g.num}`).join(",");
      this.info.productId = this.selectedGoods.map((g) => g.goodsId).join(",");
      if (Array.isArray(this.info.picUrl)) {
        this.info.picUrl = this.info.picUrl.map(item => item.url).join(",");
      }
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          const submitData = {
            ...this.info,
            list: this.selectedGoods
          };
          editMerchantOrder(submitData).then(res => {
            if (res.code === "200") {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success"
              });
              this.$router.go(-1);
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完整填写必填信息",
            type: "error"
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.card {
  margin-bottom: 20px;
}
.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>